module.exports = __webpack_public_path__ + "img/Assem2.SLDASM.9599aff3.webp";